import { Locale } from '@fanadise/common-consts';
import en from 'locales/en.json';
import pl from 'locales/pl.json';

export const DEFAULT_TRANSLATIONS: Record<Locale, Record<string, string>> = {
  en,
  pl,
};
